import { useLayoutEffect, useContext, useRef } from 'react';

import ResizeContext from './ResizeContext';
import { CellHandleComponent, ChartContainer } from './components';

const ResizeCell = ({ children, isLast, width, ...props }) => {
  const rowContext = useContext(ResizeContext);
  const refContainer = useRef(null);

  useLayoutEffect(() => {
    let element = refContainer.current;

    rowContext.addCell(element);
    return () => {
      rowContext.removeCell(element);
    };
  }, []);

  useLayoutEffect(() => {
    refContainer.current.style.flexBasis = `${width}%`;
  }, [width]);

  const handleMouseDown = (event) => {
    rowContext.onMouseDown(event, refContainer.current);
  };

  return (
    <ChartContainer ref={refContainer} {...props}>
      {children}
      {!isLast ? (
        <CellHandleComponent
          onMouseDown={handleMouseDown}
          // className={'resizeCellHandle'}
        />
      ) : null}
    </ChartContainer>
  );
};

export default ResizeCell;
